export const ExperimentsConsts = {
  EditorOOIFormPage: 'specs.bookings.EditorOOIFormPage',
  FormEditorKBContent: 'specs.bookings.FormEditorKBContent',
  MultiLocationUoU: 'specs.bookings.MultiLocationUoU',
  AddonsWithPlanOnlyUOU: 'specs.bookings.AddonsAndPlanOnlyUOU',
  CartConflictEnableSlotsTimezoneConversion:
    'specs.bookings.CartConflictEnableSlotsTimezoneConversion',
  UOUIntakeFormsIntegration: 'specs.bookings.UOUIntakeFormsIntegration',
  ShowRemainingCourseSessions: 'specs.bookings.ShowRemainingCourseSessions',
  ShowUnavailableSlotForm: 'specs.bookings.ShowUnavailableSlotForm',
  ShowErrorMessageOnInvalidIntakeForm:
    'specs.bookings.showErrorMessageOnInvalidIntakeForm',
  TimezoneAwareSlotMatching: 'specs.bookings.TimezoneAwareSlotMatching',
  DepositeOrFullAmountUoU: 'specs.bookings.DepositeOrFullAmountUoU',
  AllDayMultiDayEvents: 'specs.bookings.AllDayMultiDayEvents',
  SubscriptionPricingUoU: 'specs.bookings.SubscriptionPricingUoU',
  RelatedProductsOnServices: 'specs.bookings.relatedProductsOnServices',
  MultiCurrencyInBookingsUoU: 'multiCurrencyInBookingsUoU',
  BookingsFormWDS: 'specs.bookings.BookingsFormWDS',
  MigrateBookingsThumbnailToWds: 'migrateBookingsThumbnailToWDS',
  BookingsUseEcomCartV2: 'bookingsUseEcomCartV2',
  FormBfcacheStatusReset: 'formBfcacheStatus',
  BlockBuyPlanWhenNoAvailablePlansUoU: 'blockBuyPlanWhenNoAvailablePlansUoU',
  PlanAndBook: 'bookingsPlanAndBook',
  PricingPlansMultiplePricingVariants: 'pricingPlansMultiplePricingVariants',
  BookForSomeoneElse: 'bookForSomeoneElseUou',
  CollectParticipantForm: 'collectParticipantFormUou',
  SupportDateAndNumOfParticipantsVariantsUoU:
    'supportDateAndNumOfParticipantsVariantsUoU',
  FixPayNowPriceForUsersWithPlans: 'fixPayNowPriceForUsersWithPlans',
  ShowSlotMoreDetailsOnMobile: 'showSlotMoreDetailsOnMobile',
};
